module.exports = "<main [@fadeAnimation]=\"getRouterOutletState(o)\">\n    <router-outlet #o=\"outlet\"></router-outlet>\n</main>"